import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BaseGetProvider, DataTransformationProtocol } from "@tendercuts/http";
import { HyperTrackOrder, HyperTrackTrip } from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class HyperTrackTripService
  extends BaseGetProvider<HyperTrackTrip>
  implements DataTransformationProtocol {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices
  ) {
    super(http);
    this.delegate = this;
  }

  preProcessResponse(response: any): Array<any> {
    return response.results[0];
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof HyperTrackTrip {
    return HyperTrackTrip;
  }

  get endpoint(): string {
    return this.endpointService.fetchHyperTrackTripDetail();
  }

  get isCachable(): boolean {
    return false;
  }

  getParams(tripId: number): {
    trip_id: number;
  } {
    const params: {
      trip_id: number;
    } = {
      trip_id: tripId,
    };

    return params;
  }
}
